import { Paper, styled } from '@mui/material';
import { ModalType } from 'src/Screens/Configurator';
import { AdditionalServices } from 'src/Screens/project/components/AdditionalServices';
import ClientInformationsForm from 'src/Screens/project/components/ClientInformationsForm';
import { Installations } from 'src/Screens/project/components/Installations';
import { UpdateQuoteImage } from 'src/Screens/project/components/UpdateQuoteImage';
import CommentForm from 'src/Screens/project/components/CommentForm';
import { Assembly } from 'src/services/assemblies';
import { Control, FieldErrors, UseFormHandleSubmit, UseFormReset } from 'react-hook-form';
import { ClientInformationsFormSchema } from './useConfiguratorNavigation';

type ConfiguratorModalsProps = {
  modal: ModalType;
  setOpenedModal: (openedModal: ModalType | undefined) => void;
  assembly: Assembly | null;
  onRefresh: () => void;
  user: any;
  control: Control<ClientInformationsFormSchema>;
  errors: FieldErrors<ClientInformationsFormSchema>;
  handleSubmit: UseFormHandleSubmit<ClientInformationsFormSchema>;
  reset: UseFormReset<ClientInformationsFormSchema>;
  activeAdditionalServices: string[];
  setActiveAdditionalServices: (services: string[]) => void;
  activeInstallations: { price: number; name: string; display: boolean }[];
  setActiveInstallations: (
    installations: { price: number; name: string; display: boolean }[],
  ) => void;
};

export const ConfiguratorModals = ({
  modal,
  setOpenedModal,
  assembly,
  onRefresh,
  user,
  control,
  errors,
  handleSubmit,
  reset,
  activeAdditionalServices,
  setActiveAdditionalServices,
  activeInstallations,
  setActiveInstallations,
}: ConfiguratorModalsProps): JSX.Element => {
  switch (modal) {
    case 'editInformations': {
      return (
        <ModalContainer>
          <ClientInformationsForm
            closeForm={() => setOpenedModal(undefined)}
            control={control}
            quote={assembly?.quote}
            errors={errors}
            handleSubmit={handleSubmit}
            reset={reset}
          />
        </ModalContainer>
      );
    }
    case 'addComment': {
      return (
        <ModalContainer>
          <CommentForm
            closeForm={() => setOpenedModal(undefined)}
            quote={assembly?.quote}
            onRefresh={onRefresh}
          />
        </ModalContainer>
      );
    }
    case 'additionalServices': {
      return (
        <ModalContainer>
          {user ? (
            <AdditionalServices
              closeForm={() => setOpenedModal(undefined)}
              activeAdditionalServices={activeAdditionalServices}
              setActiveAdditionalServices={setActiveAdditionalServices}
              quote={assembly?.quote}
              errors={errors}
              handleSubmit={handleSubmit}
              reset={reset}
              userId={user.id}
              assembly={assembly}
              onRefresh={onRefresh}
            />
          ) : null}
        </ModalContainer>
      );
    }
    case 'installations': {
      return (
        <ModalContainer>
          {user ? (
            <Installations
              closeForm={() => setOpenedModal(undefined)}
              activeInstallations={activeInstallations}
              setActiveInstallations={setActiveInstallations}
              quote={assembly?.quote}
              errors={errors}
              handleSubmit={handleSubmit}
              reset={reset}
              userId={user.id}
              assembly={assembly}
              onRefresh={onRefresh}
            />
          ) : null}
        </ModalContainer>
      );
    }
    case 'quoteImage': {
      return (
        <ModalContainer>
          <UpdateQuoteImage
            closeForm={() => setOpenedModal(undefined)}
            quote={assembly?.quote}
            onRefresh={onRefresh}
          />
        </ModalContainer>
      );
    }
    default: {
      return <ModalContainer>{modal}</ModalContainer>;
    }
  }
};

const ModalContainer = styled(Paper)({
  position: 'absolute',
  width: '90%',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  overflowY: 'auto',
  maxHeight: '90%',
});
